export const formatDate = (date) => {
    if (!date) return "-";

    const safeDate =
        typeof date === "string" ? date.replace(" ", "T") : date;

    const d = new Date(safeDate);

    if (isNaN(d)) return "-";

    return new Intl.DateTimeFormat("es-CO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).format(d);
};

export const formatDateShort = (date) => {
    if (!date) return "-";

    const safeDate =
        typeof date === "string" ? date.replace(" ", "T") : date;

    const d = new Date(safeDate);

    if (isNaN(d)) return "-";

    return new Intl.DateTimeFormat("es-CO", {
        day: "numeric",
        month: "long"
    }).format(d);
};